import clsx from 'clsx';
import React from 'react';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import styles from './NavbarNavigateTabs.module.scss';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import { useLocation, useNavigate } from 'react-router';
import { Link } from 'react-router-dom';

const NavbarNavigateTabs = ({ options }) => {
  const navigate = useNavigate();

  const useRouteMatch = (items) => {
    const { pathname } = useLocation();
    const patterns = items.map((item) => item.url).flat();
    for (let i = 0; i < patterns.length; i += 1) {
      const pattern = patterns[i];
      const possibleMatch = pathname.includes(pattern) ? pattern : null;
      if (possibleMatch !== null) {
        return possibleMatch;
      }
    }

    return null;
  };

  const activeTab = options.find((item) => useRouteMatch(options) === item.url) ?? options[0];
  const activeSubTabs = options.find((item) => activeTab.url === item.url)?.subMenu ?? [];
  const activeSubTab =
    activeSubTabs.find((item) => item.url === useRouteMatch(activeSubTabs)) ?? activeSubTabs[0];

  const onSelectChange = (evnt) => {
    const { value } = evnt.target;
    navigate(value);
  };

  return (
    <>
      <div className={styles.tabsContainer}>
        <div>
          <Tabs
            TabIndicatorProps={{ style: { backgroundColor: '#143471' } }}
            centered
            value={activeTab?.url ?? ''}
            className={styles.tabs}
            scrollButtons
          >
            {options.map((item) => (
              <Tab
                key={item.name}
                value={item.url ?? ''}
                label={item.name}
                to={item.url}
                className={clsx(
                  styles.tabItem,
                  activeTab?.url === item.name ? styles.activeItem : null
                )}
                sx={{ margin: '0px 30px', padding: 0 }}
                component={Link}
              />
            ))}
          </Tabs>
        </div>
        {activeSubTabs && activeSubTabs.length > 0 && (
          <div className={styles.rowWrapper}>
            <Tabs
              TabIndicatorProps={{ style: { backgroundColor: '#143471' } }}
              centered
              value={activeSubTab?.url ?? ''}
              className={styles.tabs}
              scrollButtons
            >
              {activeSubTabs.map((subitem) => (
                <Tab
                  value={subitem.url ?? ''}
                  label={subitem.name}
                  to={subitem.url}
                  className={clsx(
                    styles.tabItem,
                    activeTab?.url === subitem.name ? styles.activeItem : null
                  )}
                  sx={{ margin: '0px 30px', padding: 0 }}
                  component={Link}
                />
              ))}
            </Tabs>
          </div>
        )}
      </div>
      <Select
        value={activeTab.url}
        className={styles.navbarSelectWrapper}
        onChange={onSelectChange}
        size="medium"
        sx={{
          '.MuiOutlinedInput-notchedOutline': { border: '0 !important' },
          '.MuiSelect-select': { padding: '12px 0 12px 18px !important' },
        }}
      >
        {options &&
          options.length &&
          options.map((item) => (
            <MenuItem
              className={clsx(
                styles.navbarButton,
                activeTab.name === item.name ? styles.active : ''
              )}
              key={item.name}
              value={item.url}
            >
              {item.name}
            </MenuItem>
          ))}
      </Select>
      {activeSubTabs && activeSubTabs.length > 0 && (
        <div>
          <Select
            value={activeSubTab.url}
            className={styles.navbarSelectWrapper}
            onChange={onSelectChange}
            size="medium"
            sx={{
              '.MuiOutlinedInput-notchedOutline': { border: '0 !important' },
              '.MuiSelect-select': { padding: '12px 0 12px 18px !important' },
            }}
          >
            {activeSubTabs.map((subitem) => (
              <MenuItem
                className={clsx(
                  styles.navbarButton,
                  activeSubTab.url === subitem.url ? styles.active : ''
                )}
                key={subitem.name}
                value={subitem.url}
              >
                {subitem.name}
              </MenuItem>
            ))}
          </Select>
        </div>
      )}
    </>
  );
};

export default NavbarNavigateTabs;
